import { render, staticRenderFns } from "./TownsMap.vue?vue&type=template&id=d53f4c70&"
import script from "./TownsMap.vue?vue&type=script&lang=js&"
export * from "./TownsMap.vue?vue&type=script&lang=js&"
import style0 from "./TownsMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports